import React, { useState, useCallback, useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import AdminPage from '../../components/admin/AdminPage';
import { AdminPreQualificationList } from './models/preQualificationModel';
import PreQualificationListCard from './components/PreQualificationListCard';
import PreQualificationListSearch from './components/PreQualificationListSearch';
import { getPreQualificationListEndpoint } from './services/preQualificationService';
import useAuth from '../../hooks/useAuth';
import useAdminEntity from '../../hooks/useAdminEntity';
import LoadingCard from '../../components/LoadingCard';

const PreQualificationList = () => {
  const [filteredPqs, setFilteredPqs] = useState<AdminPreQualificationList[]>(
    [],
  );
  const [errorAlert, setErrorAlert] = useState<string | null>(null);

  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  const getPreQualifications = useCallback(
    () => getPreQualificationListEndpoint(token),
    [token],
  );

  const [preQualifications, _, isLoading] = useAdminEntity<
    AdminPreQualificationList[]
  >(getPreQualifications, setErrorAlert);

  const handleFilterChange = (filtered: AdminPreQualificationList[]) => {
    setFilteredPqs(filtered);
  };

  useEffect(() => {
    setFilteredPqs(preQualifications);
  }, [preQualifications]);

  if (isLoading) {
    return <LoadingCard name="Pre-calificaciones" parent_name="Investor" />;
  }

  return (
    <AdminPage
      name="Pre-calificaciones"
      parentName="Investor"
      globalAlertOptions={{
        success: false,
        warning: Boolean(errorAlert),
        onConfirm: () => setErrorAlert(null),
        title: 'Error',
        text: errorAlert || '',
      }}
    >
      <div>
        <h2 className="h3 fw-bold mb-4">Solicitudes de Pre-calificación</h2>
        <PreQualificationListSearch
          pqs={preQualifications || []}
          onFilterChange={handleFilterChange}
        />
        <Row>
          {filteredPqs && filteredPqs.length > 0 ? (
            filteredPqs.map((pq) => (
              <Col key={pq.id} lg={3} md={4} className="mb-4">
                <PreQualificationListCard pq={pq} />
              </Col>
            ))
          ) : (
            <Col>
              <p className="text-center text-muted">
                No se encontraron pre-calificaciones
              </p>
            </Col>
          )}
        </Row>
      </div>
    </AdminPage>
  );
};

export default PreQualificationList;
